import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap-5';
import Select from 'react-select';

interface CompanyTerritory {
  id: number;
  displayLabel: string;
}

// Represents the shape expected by react-select component (value/label format)
// Transformed from CompanyTerritory for use in the dropdown and component state
interface TerritoryOption {
  value: number;
  label: string;
}

export interface TerritoriesProps {
  allCompanyTerritories: CompanyTerritory[];
  companyTerritories: CompanyTerritory[];
  isCorporateUser: Boolean;
}

function initialTerritoriesSelected(
  territoryOptions: TerritoryOption[],
  companyTerritories: CompanyTerritory[]
): TerritoryOption[] {
  const selectedTerritoryIds = companyTerritories.map(t => t.id);
  return territoryOptions.filter(o => selectedTerritoryIds.includes(o.value));
}

export default function Territories({
  allCompanyTerritories,
  companyTerritories,
  isCorporateUser
}: TerritoriesProps) {
  const territoryOptions = allCompanyTerritories.map(t => ({ value: t.id, label: t.displayLabel }));
  const [selectedTerritories, setSelectedTerritories] = useState<TerritoryOption[]>(
    () => initialTerritoriesSelected(territoryOptions, companyTerritories)
  );

  return (
    <>
      <h5 className="fw-semibold">Territories</h5>
      <Row>
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            isDisabled={!isCorporateUser}
            options={territoryOptions}
            value={selectedTerritories}
            onChange={(value) => setSelectedTerritories(value as TerritoryOption[])}
          />
        </Col>
      </Row>

      {selectedTerritories.map((territory) => (
        <input
          key={territory.value}
          name="company[territory_ids][]"
          type="hidden"
          value={territory.value}
        />
      ))}
    </>
  );
}
